import { mapGetters } from 'vuex'

import vSelect from 'vue-select'
import { UserIcon } from 'vue-feather-icons'
import { ToggleButton } from 'vue-js-toggle-button'
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'

export default {
  name: 'LockerFiltersModal',
  components: { vSelect, ToggleButton, UserIcon },
  extends: BaseModal,
  data: function () {
    return {
      modelValue: false,
    }
  },
  computed: {
    ...mapGetters({
      showMyLockersOnly: 'showMyLockersOnly',
    }),
  },
  watch: {
    modelValue: {
      handler: function (newVal) {
        this.$store.commit('setShowMyLockersOnly', newVal)
      },
    },
  },
  mounted() {
    this.modelValue = this.showMyLockersOnly
  },
}

// TODO: this.lockers = lockersStore.state.lockers
// this.search.showMyLockersOnly =
//   this.currentUser.isAdmin || this.currentUser.hasAnyAdminMembers
//     ? true
//     : this.data.showMyLockersOnly
